import appManager from '@app/appManager';
import { PcsConversationFetchedEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { startTask } from '../mutations/startTask';
import { SpeedToLeadTaskAttributes } from '../types';
import { findStlTaskForCall } from './findStlTaskForCall';

const logger = appManager.logger('SpeedToLead');

/**
 * Handles phone.pcs.conversation.fetched for STL tasks.
 * Stores PCS conversation sid as a task attribute and fires startTask to
 * associate the interaction with the task record and mark it in_progress.
 * The STL task ID is NOT updated — it keeps the API taskId throughout its lifecycle.
 */
function handleStlPcsConversationFetched(ev: PcsConversationFetchedEvent) {
  const { remoteIdentity, direction } = ev.phoneStateUpdateEvent.callState;
  if (direction !== 'originating') return;

  const stlTask = findStlTaskForCall(remoteIdentity);
  if (!stlTask) return;

  const { sid: pcsConversationSid } = ev.pcsConversation;
  const { tenantId } = stlTask.attributes as SpeedToLeadTaskAttributes;

  logger.info('stl:pcs-conversation-fetched:starting', {
    taskId: stlTask.id,
    pcsConversationSid,
  });

  TasksModule.setTaskAttribute(
    stlTask.id,
    'pcsConversationSid',
    pcsConversationSid,
  );

  // Fire-and-forget: this handler is synchronous; startTask runs in the background.
  startTask({
    tenantId,
    taskId: stlTask.id,
    channelId: pcsConversationSid,
  })
    .then((success) => {
      if (success) {
        logger.info('stl:pcs-conversation-fetched:started', {
          taskId: stlTask.id,
        });
      } else {
        logger.warn(
          'stl:pcs-conversation-fetched:start-task-failed-returned-false',
          {
            taskId: stlTask.id,
          },
        );
      }
    })
    .catch((err) => {
      logger.error('stl:pcs-conversation-fetched:start-task-failed', {
        taskId: stlTask.id,
        err,
      });
    });
}

export default handleStlPcsConversationFetched;
